import React from 'react';

export const defaultAppLowerName = '';

export const MarkdownSafeMdxViewerAppLowerNameContext = React.createContext(defaultAppLowerName);
